import React from "react";

const AltarSection = () => {
  return (
    <section className="bg-[#fbf7ee]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-20 lg:py-24">
        <div className="flex flex-col items-center">
          <img
            src="/assets/altar.png"
            alt="Traditional Catholic altar with tabernacle, candles, and adoring angels"
            className="w-full max-w-[820px] object-contain select-none"
            draggable="false"
          />
        </div>
      </div>
    </section>
  );
};

export default AltarSection;
